import React from 'react';
import _ from 'lodash';
import { EXPORT_MANAGEMENT_TASK_MAP } from '../../../HelperMethods/AgGridConstants';
// import apiService from '../../service/apiService';

export const validationHelper = (selectedDateRange, taskTypeIdSelected, fieldId) => {
  const { startDate, endDate } = selectedDateRange;
  let validationState = true;
  let message = '';
  if (_.isEmpty(fieldId)) {
    validationState = false;
    message = 'No field found';
  }
  if (_.isEmpty(taskTypeIdSelected)) {
    validationState = false;
    message = 'Kindly select Task Type';
  }
  if (_.isEmpty(startDate) && _.isEmpty(endDate)) {
    validationState = false;
    message = 'Kindly select Task Type';
  }

  return { validation: validationState, message };
};

export function isParentTask(task) {
  const { workflowVersions } = task;
  return workflowVersions;
}

const objtoString = (obj) => {
  const stringArray = [];

  Object.keys(obj).forEach((e) => {
    stringArray.push(obj[e]);
  });

  return stringArray.join(' ');
};

export const formDataFormatter = (rowData) => {
  Object.keys(rowData).forEach((e) => {
    if (_.isObject(rowData[e])) {
      rowData[e] = objtoString(rowData[e]);
    }
  });
  return rowData;
};

// async function stringTos3Url(string, id) {
//   if (!_.isEmpty(string)) {
//     const signedUrl = await apiService.getDownloadUrlForS3Key(string);
//     return { signedUrl, id };
//   }
//   return '';
// }

export function processFormElementsforAttachment(elements, resp, response, parentKey) {
  for (const el of elements) {
    const field = parentKey ? `${parentKey}_${el.id}` : el.id;
    if (el.type === 'section') {
      processFormElementsforAttachment(el.elements || [], resp, response, el.id);
    } else if (el.type === 'header' || el.type === 'description') {
      continue;
    } else if (el.type === 'fileupload') {
      // const fieldValue = response.filter((e) => e[field]).map((e) => stringTos3Url(e[field], e.id));
      resp.push(field);
      // const result = await Promise.all(fieldValue);
      // const resultDict = _.keyBy(result, 'id');

      // response.forEach((e, i) => {
      //   if (resultDict[e.id]) {
      //     const tempResponse = response[i];
      //     tempResponse[field] = resultDict[e.id].signedUrl;
      //     resp.push(tempResponse);
      //   } else {
      //     resp.push(e);
      //   }
      // });
    } else {
      continue;
    }
  }
}

const underLinedTextCellRenderer = (params) => {
  return (
    <span style={{ textDecoration: 'underline' }}>
      {params.value ? <span style={{ textAlign: 'center', display: 'block' }}>Download</span> : ''}
    </span>
  );
};

function processFormElements(elements, resp, parentKey) {
  for (const el of elements) {
    const field = parentKey ? `${parentKey}_${el.id}` : el.id;
    const headerName = el.state?.label
      .split('')
      .map((e1, i) => (i === 0 ? e1.toUpperCase() : e1))
      .join('');
    if (el.type === 'section') {
      processFormElements(el.elements || [], resp, el.id);
    } else if (el.type === 'header' || el.type === 'description') {
      continue;
    } else if (el.type === 'fileupload') {
      resp.push({
        field,
        headerName,
        cellRenderer: underLinedTextCellRenderer,
      });
    } else {
      resp.push({ field, headerName });
    }
  }
}

export const columnDefsForCustomGlobalAttributeandFormAttribute = (data) => {
  const { schema, globalAttribute, globalAttributeIds, formSchema, customAttribute } = data;

  const columnDefs = EXPORT_MANAGEMENT_TASK_MAP.map((e) => {
    if (e.field === 't_attachments') {
      return {
        ...e,
        cellRenderer: underLinedTextCellRenderer,
      };
    }
    return { ...e };
  });
  if (!_.isEmpty(schema)) {
    Object.keys(schema).forEach((e) => {
      if (e.includes('c_') && customAttribute) {
        columnDefs.push({
          headerName: schema[e].displayName
            .split('')
            .map((e1, i) => (i === 0 ? e1.toUpperCase() : e1))
            .join(''),
          field: e,
          filter: 'agTextColumnFilter',
        });
      }
    });
  }
  if (!_.isEmpty(globalAttributeIds) && !_.isEmpty(globalAttribute)) {
    columnDefs.push(
      ...globalAttribute
        .filter((e) => globalAttributeIds.some((e1) => e1 === e.id))
        .map((e2) => ({
          headerName: e2.attributeDisplayName
            .split('')
            .map((e1, i) => (i === 0 ? e1.toUpperCase() : e1))
            .join(''),
          field: `g_${e2.attributeName}`,
          filter: 'agTextColumnFilter',
        }))
    );
  }
  if (!_.isEmpty(formSchema)) {
    const resp = [];
    processFormElements(_.get(formSchema, 'data.elements') || [], resp);

    columnDefs.push(...resp);
  }

  return columnDefs;
};

// export const columnDefsForFormTable = (data) => {
//   const { formSchema } = data;
//   const columnDefs = [...EXPORT_MANAGEMENT_TASK_MAP];
//   const resp = [];
//   processFormElements(_.get(formSchema, 'data.elements') || [], resp);
//   columnDefs.push(...resp);
//   return columnDefs;
// };
